import { ICellRendererParams } from '@ag-grid-community/core'
import DraftsQueueCell from '../components/DraftsQueueCell'

// Drafts shares its columns with In Review and Completed; only Drafts pins
// unfinished uploads, so their cells are swapped in here rather than in the shared defs
export const withDraftsQueueCells = <T extends { field?: string }>(
  colDefs: T[],
  {
    clientNameLookup,
    onChanged,
    canDismiss,
  }: {
    clientNameLookup: Record<string, string>
    onChanged: () => void
    canDismiss: boolean
  }
) =>
  colDefs.map((colDef) => ({
    ...colDef,
    cellRendererSelector: (params: ICellRendererParams) =>
      params.node.rowPinned
        ? {
            component: DraftsQueueCell,
            params: {
              field: colDef.field,
              job: params.data,
              clientNameLookup,
              onChanged,
              canDismiss,
            },
          }
        : undefined,
  }))
